import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const CATEGORIES = ['all', 'log', 'photo', 'work', 'object', 'diy', 'zines', 'sketch', 'misc'];

const Header = ({ activeCategory, onCategoryChange }) => {
  const { user } = useAuth();

  return (
      <header className="site-header">
        <div className="header-top">
          <Link to="/" className="logo">
            <span className="logo-icons">
              <img src={process.env.PUBLIC_URL + '/logo.PNG'} alt="dias logo" className="logo-img" style={{ height: 28, width: 28, objectFit: 'contain' }} />
            </span>
            <span className="logo-text">dias</span>
          </Link>

          <nav className="category-nav">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`cat-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => onCategoryChange(cat)}
            >
              {cat}
            </button>
          ))}
          {user && (
            <Link to="/admin" className="cat-btn admin-btn">admin</Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
